import { add, isPast, set } from 'date-fns'
import { formatDateWithTimeToBE } from '../../../../helpers/date'

export const formatStartDate = startDate => {
  // Handle edge cases: empty strings
  if (!startDate || startDate === '') {
    return null
  }

  const dateObject = new Date(startDate)

  const initialStartDate = set(dateObject, {
    hours: 0,
    minutes: 0
  })

  // if start date is in past > set final start date as (current time + one minute)
  if (isPast(initialStartDate)) {
    return formatDateWithTimeToBE(add(new Date(), { minutes: 1 }))
  }

  return formatDateWithTimeToBE(initialStartDate)
}

export const formatEndDate = endDate => {
  // Handle edge cases: empty strings
  if (!endDate || endDate === '') {
    return null
  }

  const dateObject = new Date(endDate)

  return formatDateWithTimeToBE(
    set(dateObject, {
      hours: 23,
      minutes: 59
    })
  )
}
